<template>
  <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">

    <!--操控-->
    <div class="pl-4">
      <el-tooltip content="点击即可开门" effect="dark" placement="top">
        <el-button size="mini" @touchstart="sendOpenDoor(deviceInfo.id)" @click="sendOpenDoor(deviceInfo.id)">开门</el-button>
      </el-tooltip>
    </div>
    <!--      开门记录-->
    <el-row style="padding: 20px">
      <el-table
        :data="doorLogs.records"
        :height="tableHeight"
        border
        class="m-auto"
        style="width: 100%;">
        <el-table-column
          align="center"
          label="设备名称"
          prop="deviceName"
          width="300">
        </el-table-column>
        <el-table-column
          align="center"
          label="开门方式"
          prop="doorCardName">
        </el-table-column>
        <el-table-column
          align="center"
          label="人员名称"
          prop="creditPersonName">
        </el-table-column>
        <el-table-column
          align="center"
          label="开门时间"
          prop="openDate">
        </el-table-column>
      </el-table>
    </el-row>
    <el-pagination
      :current-page="doorLogs.current" :hide-on-single-page="true"
      :page-size="doorLogs.size"
      :small="true"
      :total="doorLogs.total"
      class="mb-4 mt-3 text-center"
      layout="prev, pager, next"
      style="padding-left: 35px;width: 92%;"
      @current-change="pageChange">
    </el-pagination>
  </div>
</template>

<script>
import {getEntranceGuardList, openZkDoor} from "@/network/entranceguard";
import {setCookie} from "@/utils/common";
import {passwordVerifiers} from "@/network/account";

export default {
  name: "ZkDoor",
  props: ['deviceInfo'],
  data() {
    return {
      // 开门记录
      doorLogs: {},
      page: {
        data: {
          max: 10,
          index: 1
        }
      }
    }
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.40
    }
  },
  mounted() {
    this.getData(this.page.data.index, this.page.data.max, this.deviceInfo.apiId)
  },
  methods: {
    getData(index, max, apiId) {
      getEntranceGuardList(index, max, apiId).then(res => {
        if (res.code === 0) {
          this.doorLogs = res.data
        }
      })
    },
    // 翻页
    pageChange(page) {
      this.getData(page, this.page.data.max, this.deviceInfo.apiId)
    },
    // 发送开门命令
    sendOpenDoor(deviceId) {
      this.$prompt('请输入系统登录密码确认身份', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'password',
      }).then(({value}) => {
        passwordVerifiers(value).then(res => {
          if (res.data === true) {
            setCookie("passwordVerification", '1', null);
            openZkDoor(deviceId).then(res => {
              if (res.code === 0) {
                this.$message.success("控制开门成功")
              }else {
                this.$message.error("控制开门失败")
              }
            })
          } else {
            this.$message({
              message: '系统登录密码错误',
              type: 'warning'
            });
            return;
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    }
  }
}
</script>

<style scoped>

</style>
